import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Skeleton, Typography } from '@mui/material';

import { ReactComponent as LogoWithoutText } from 'assets/icons/LogoWithoutText.svg';

import { DotsLoader } from 'components/_basic/DotsLoader';

import styles from './PreviewSectionLoader.module.scss';

interface IPreviewSectionLoaderProps {
  loading: boolean;
}

export const PreviewSectionLoader: React.FC<IPreviewSectionLoaderProps> = ({ loading }) => {
  const { t } = useTranslation();

  if (!loading) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.skeletonContainer}>
        <Box>
          <Box className={styles.skeletonHeader}>
            <Skeleton height={40} width="50%" />
            <Skeleton height={40} width="5%" />
          </Box>
          <Skeleton />
        </Box>
        <Box>
          <Skeleton height={30} width="60%" />
          <Skeleton width="40%" />
        </Box>
        <Box>
          <Skeleton height={30} width="60%" />
          <Skeleton width="40%" />
        </Box>
        <Box>
          <Skeleton height={30} width="60%" />
          <Skeleton width="40%" />
        </Box>
        <Box>
          <Skeleton height={30} width="60%" />
          <Skeleton width="40%" />
        </Box>
        <Box>
          <Skeleton height={30} width="60%" />
          <Skeleton width="40%" />
        </Box>

        <Skeleton />
      </Box>

      <Box className={styles.loaderContainer}>
        <Box className={styles.flex}>
          <Box className={styles.sticky}>
            <Box className={styles.report}>
              <LogoWithoutText className={styles.icon} />
              <Typography variant="h3" className={styles.title}>
                {t('previewLoader.creatingPdf')}
              </Typography>
              <Box textAlign="center" className={styles.text}>
                <Typography variant="body1">{t('previewLoader.pleaseWait')}</Typography>
                <Typography variant="body1">{t('previewLoader.pdfCreating')}</Typography>
              </Box>
            </Box>
            <Box className={styles.sectionsList}>
              <DotsLoader className={styles.onePageLoaderDot} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
